export default {"src":"/_next/static/media/transferUser.7ed6b2b3.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};